import angular from 'angular';
import uiRouter from 'angular-ui-router';
import eventEditPageComponent from './eventEditPage.component';

let eventEditPageModule = angular.module('eventEditPage', [
  uiRouter
])

.component('eventEditPage', eventEditPageComponent)

.name;

export default eventEditPageModule;
